(() => {
  class MegaskaProduct {
    constructor(root) {
      this.root = root;
     this.form = root.querySelector('.mk-product-form');
this.formInner = root.querySelector('[data-product-form]');
this.productJsonEl = root.querySelector('[data-product-json]');
      this.variantIdInput = root.querySelector('[data-variant-id-input]');
      this.priceCurrent = root.querySelector('[data-price-current]');
      this.priceCompare = root.querySelector('[data-price-compare]');
      this.priceBadge = root.querySelector('[data-price-badge]');
      this.prepaidOffer = root.querySelector('[data-prepaid-offer]');
      this.prepaidPrice = root.querySelector('[data-prepaid-price]');
      this.stockText = root.querySelector('[data-stock-text]');
      this.mediaSaleBadges = Array.from(root.querySelectorAll('[data-media-sale-badge]'));
      this.stickyRoot = root.querySelector('[data-product-sticky]');
      this.addToCartBtn = root.querySelector('[data-add-to-cart]');
      this.stickyAddBtn = root.querySelector('[data-sticky-add]');
      this.stickyPrice = root.querySelector('[data-sticky-price]');
      this.stickySelection = root.querySelector('[data-sticky-selection]');
      this.stickyOfferBtn = root.querySelector('[data-sticky-offer]');
      this.sizeSheet = root.querySelector('[data-size-sheet]');
      this.sizeSheetOptions = root.querySelector('[data-size-sheet-options]');
      this.sizeSheetProceed = root.querySelector('[data-size-sheet-proceed]');
      this.sizeSheetCloseEls = root.querySelectorAll('[data-size-sheet-close]');
      this.statusMessage = root.querySelector('[data-product-status]');
this.isProcessingAction = false;

      this.slides = Array.from(root.querySelectorAll('[data-media-slide]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-media-thumb]'));
      this.viewport = root.querySelector('[data-media-viewport]');

      this.isCustomerLoggedIn = this.root.dataset.customerLoggedIn === 'true';
      this.colorOptionIndex = parseInt(this.root.dataset.colorOptionIndex || '-1', 10);
      if (Number.isNaN(this.colorOptionIndex)) this.colorOptionIndex = -1;
      this.activeMediaColor = null;

      if (!this.form || !this.productJsonEl || !this.variantIdInput) return;

      this.product = this.parseProduct();
      if (!this.product) return;

      this.moneyFormat =
        window.Shopify && window.Shopify.money_format
          ? window.Shopify.money_format
          : '₹{{amount}}';

      this.optionGroups = Array.from(root.querySelectorAll('[data-option-group]'));

      this.selectedOptions = this.getInitialSelectedOptions();
      this.currentVariant =
        this.findVariantById(this.product.selected_variant_id) ||
        this.findVariantByOptions(this.selectedOptions) ||
        this.product.variants[0] ||
        null;

      this.pendingAction = null;
      this.resetTransientUi();
      this.bindEvents();
      this.syncFromVariant(this.currentVariant, false);
      this.setupSizeGuideBridge();
      this.setupIntersectionObserver();
    }
showStatusMessage(message) {
  if (!this.statusMessage) return;
  this.statusMessage.textContent = message;
  this.statusMessage.hidden = false;
  this.statusMessage.classList.add('is-visible');
}
bindPageRestoreReset() {
  window.addEventListener('pageshow', () => {
    this.resetTransientUi();
    this.syncAvailabilityUI();
    this.syncStickyUI();
    this.syncSizeSheetState();
  });

  window.addEventListener('pagehide', () => {
    this.resetTransientUi();
  });
}
hideStatusMessage() {
  if (!this.statusMessage) return;
  this.statusMessage.textContent = '';
  this.statusMessage.hidden = true;
  this.statusMessage.classList.remove('is-visible');
}

setProcessingState(isProcessing, message = '') {
  this.isProcessingAction = isProcessing;

  const buttons = [
    this.addToCartBtn,
    this.stickyAddBtn,
    this.sizeSheetProceed
  ].filter(Boolean);

  buttons.forEach((button) => {
    button.disabled = isProcessing;
    button.classList.toggle('is-loading', isProcessing);
  });

  if (isProcessing && message) {
    this.showStatusMessage(message);
  } else {
    this.hideStatusMessage();
  }
}
    parseProduct() {
      try {
        return JSON.parse(this.productJsonEl.textContent);
      } catch (error) {
        console.error('[Megaska PDP] Invalid product JSON', error);
        return null;
      }
    }
    findVariantById(variantId) {
      if (!variantId || !this.product || !Array.isArray(this.product.variants)) return null;
      return this.product.variants.find((variant) => String(variant.id) === String(variantId)) || null;
    }

  bindEvents() {
  this.bindOptionValues();
  this.bindMediaThumbs();
  this.bindMediaSwipe();
  this.bindBuyActions();
  this.bindStickyEnhancements();
  this.bindSizeSheet();
  this.bindMediaZoom();
  this.bindPageRestoreReset();
}
    bindOptionValues() {
      const optionButtons = this.root.querySelectorAll('[data-option-value]');

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.dataset.optionSoldout === 'true') return;

          const optionName = button.dataset.optionName;
          const optionValue = button.dataset.optionValueLabel;

          if (!optionName || !optionValue) return;

          this.setSelectedOption(optionName, optionValue);
          this.syncSizeSheetState();
        });
      });
    }

    bindMediaThumbs() {
      if (!this.thumbs.length || !this.slides.length) return;

      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          this.showSlideByIndex(index);
        });
      });
    }

    bindMediaSwipe() {
      if (!this.viewport || !this.slides.length) return;

      let startX = 0;
      let startY = 0;

      this.viewport.addEventListener(
        'touchstart',
        (e) => {
          const t = e.changedTouches[0];
          startX = t.clientX;
          startY = t.clientY;
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchend',
        (e) => {
          const t = e.changedTouches[0];
          const deltaX = t.clientX - startX;
          const deltaY = t.clientY - startY;

          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

          this.stepSlide(deltaX < 0 ? 1 : -1);
        },
        { passive: true }
      );
    }

    bindMediaZoom() {
      const triggers = this.root.querySelectorAll('[data-media-zoom-open]');

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const image = trigger.querySelector('img');
          if (!image) return;
          window.open(image.currentSrc || image.src, '_blank');
        });
      });
    }

    getActiveSlideIndex() {
      const idx = this.slides.findIndex((slide) => !slide.hidden);
      return idx >= 0 ? idx : 0;
    }

    showSlideByIndex(index) {
      if (!this.slides.length) return;

      const safeIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, i) => {
        const active = i === safeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });

      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === safeIndex);
      });

      this.syncSlideVideos();
    }

    // Indexes of slides that belong to the selected colour (or are shared).
    getNavigableSlideIndexes() {
      const indexes = [];
      this.slides.forEach((slide, i) => {
        if (!slide.hasAttribute('data-media-excluded')) indexes.push(i);
      });
      return indexes.length ? indexes : this.slides.map((_slide, i) => i);
    }

    stepSlide(direction) {
      const indexes = this.getNavigableSlideIndexes();
      const position = indexes.indexOf(this.getActiveSlideIndex());
      const next = position < 0 ? 0 : (position + direction + indexes.length) % indexes.length;
      this.showSlideByIndex(indexes[next]);
    }

    // Native product videos: play (muted) while their slide is showing, pause otherwise.
    syncSlideVideos() {
      this.slides.forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          if (slide.hidden) {
            if (!video.paused) video.pause();
            return;
          }

          if (!video.paused) return;

          video.muted = true;
          video.playsInline = true;
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        });
      });
    }

    getVariantColor(variant) {
      if (!variant || this.colorOptionIndex < 0) return null;
      return variant[`option${this.colorOptionIndex + 1}`] || null;
    }

    // Show only the given colour's gallery (plus shared media). Returns true when the colour changed.
    applyMediaColor(color) {
      if (this.colorOptionIndex < 0 || !color || color === this.activeMediaColor) return false;

      this.activeMediaColor = color;
      const colorHasMedia = this.slides.some((slide) => slide.dataset.mediaColor === color);

      const isExcluded = (el) => {
        const mediaColor = el.dataset.mediaColor || '';
        return colorHasMedia && mediaColor !== '' && mediaColor !== color;
      };

      this.slides.forEach((slide) => {
        slide.toggleAttribute('data-media-excluded', isExcluded(slide));
      });

      this.thumbs.forEach((thumb) => {
        thumb.hidden = isExcluded(thumb);
      });

      return true;
    }
bindStickyEnhancements() {
  if (this.stickyOfferBtn) {
    this.stickyOfferBtn.addEventListener('click', () => {
      this.copyStickyCoupon();
    });
  }
}
  bindBuyActions() {
  if (this.form) {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
    });
  }

  if (this.addToCartBtn) {
    this.addToCartBtn.addEventListener('click', async (event) => {
      if (this.isProcessingAction) return;

      if (!this.currentVariant || !this.currentVariant.available) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      if (this.isMobile() && this.hasSizeOption()) {
  this.openSizeSheet('add');
  return;
}

      await this.addCurrentVariantToBagAndGoToBag();
    });
  }

  if (this.stickyAddBtn) {
  this.stickyAddBtn.addEventListener('click', async () => {
    if (this.isProcessingAction) return;
    if (!this.currentVariant || !this.currentVariant.available) return;

    if (this.hasSizeOption()) {
  this.openSizeSheet('add');
  return;
}

    await this.addCurrentVariantToBagAndGoToBag();
  });
}

}
  bindSizeSheet() {
  if (!this.sizeSheet) return;

  this.sizeSheetCloseEls.forEach((el) => {
    el.addEventListener('click', () => {
      this.pendingAction = null;
      this.closeSizeSheet();
    });
  });

  if (this.sizeSheetOptions) {
    this.sizeSheetOptions.addEventListener('click', (event) => {
      const button = event.target.closest('[data-size-sheet-option]');
      if (!button) return;
      if (button.dataset.optionSoldout === 'true') return;

      const optionName = button.dataset.optionName;
      const optionValue = button.dataset.optionValueLabel;

      if (!optionName || !optionValue) return;

      this.applyOptionValue(optionName, optionValue);
      this.syncSizeSheetState();
    });
  }

  if (this.sizeSheetProceed) {
  this.sizeSheetProceed.addEventListener('click', async () => {
    if (!this.getSelectedSize()) return;
    if (!this.currentVariant || !this.currentVariant.available) return;

    const action = this.pendingAction;
    this.pendingAction = null;

    this.closeSizeSheet();

    if (action === 'add') {
      await this.addCurrentVariantToBagAndGoToBag();
    }
  });

}

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && this.sizeSheet.classList.contains('is-open')) {
      this.pendingAction = null;
      this.closeSizeSheet();
    }
  });
}


    getInitialSelectedOptions() {
      const initial = [];

      this.optionGroups.forEach((group, index) => {
        const activeBtn = group.querySelector('[data-option-value].is-active');

        if (activeBtn) {
          initial[index] = activeBtn.dataset.optionValueLabel;
          return;
        }

        const firstAvailable = group.querySelector('[data-option-value]');
        initial[index] = firstAvailable ? firstAvailable.dataset.optionValueLabel : null;
      });

      return initial;
    }
resetTransientUi() {
  if (this.statusMessage) {
    this.statusMessage.textContent = '';
    this.statusMessage.hidden = true;
    this.statusMessage.classList.remove('is-visible');
  }

  if (this.sizeSheetProceed) {
    this.sizeSheetProceed.disabled = false;
    this.sizeSheetProceed.classList.remove('is-loading');
  }

  if (this.addToCartBtn) {
    this.addToCartBtn.disabled = !this.currentVariant || !this.currentVariant.available;
    this.addToCartBtn.classList.remove('is-loading');
  }

  if (this.stickyAddBtn) {
    this.stickyAddBtn.disabled = !this.currentVariant || !this.currentVariant.available;
    this.stickyAddBtn.classList.remove('is-loading');
  }

  this.pendingAction = null;

  if (this.sizeSheet) {
    this.sizeSheet.classList.remove('is-open');
    this.sizeSheet.setAttribute('aria-hidden', 'true');
    this.sizeSheet.hidden = true;
  }

  document.documentElement.classList.remove('mk-size-sheet-open');
  document.body.classList.remove('mk-size-sheet-open');
}
    setSelectedOption(optionName, optionValue) {
      const group = this.optionGroups.find((item) => item.dataset.optionName === optionName);
      if (!group) return;

      const position = parseInt(group.dataset.optionPosition || '0', 10) - 1;
      if (position < 0) return;

      this.selectedOptions[position] = optionValue;

      const matchedVariant = this.findVariantByOptions(this.selectedOptions);

      if (matchedVariant) {
        this.currentVariant = matchedVariant;
        this.syncFromVariant(matchedVariant, true);
      } else {
        this.syncOptionUI();
      }
    }

    applyOptionValue(optionName, optionValue) {
      const target = this.root.querySelector(
        `[data-option-value][data-option-name="${CSS.escape(optionName)}"][data-option-value-label="${CSS.escape(optionValue)}"]`
      );

      if (!target || target.dataset.optionSoldout === 'true') return false;

      target.click();
      return true;
    }

    findVariantByOptions(selectedOptions) {
      if (!this.product || !Array.isArray(this.product.variants)) return null;

      return (
        this.product.variants.find((variant) => {
          return [variant.option1, variant.option2, variant.option3].every((value, index) => {
            const selected = selectedOptions[index];
            if (!selected) return true;
            return value === selected;
          });
        }) || null
      );
    }

  syncFromVariant(variant, updateHistory = false) {
  if (!variant) return;

  this.currentVariant = variant;
  this.selectedOptions = [variant.option1, variant.option2, variant.option3];

  this.syncOptionUI();
  this.syncVariantInput();
  this.syncPriceUI();
  this.syncAvailabilityUI();
  this.syncStickyUI();
  this.syncMediaForVariant();
  this.syncSizeSheetState();

  if (updateHistory) {
    this.updateUrlWithVariant(variant.id);
  }
}
syncStickyUI() {
  if (!this.stickyRoot || !this.currentVariant) return;

  const price = Number(this.currentVariant.price || 0);
  const compareAtPrice = Number(this.currentVariant.compare_at_price || 0);
  const hasDiscount = compareAtPrice > price;
  const discountPercent = hasDiscount
    ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice)
    : 0;

  if (this.stickyPrice) {
    this.stickyPrice.innerHTML = hasDiscount
      ? `
        <span class="mk-product-sticky__price-current">${this.formatMoney(price)}</span>
        <span class="mk-product-sticky__price-discount">${discountPercent}% OFF</span>
      `
      : `
        <span class="mk-product-sticky__price-current">${this.formatMoney(price)}</span>
      `;
  }

  const hasSizeOption = this.hasSizeOption();
  const selectedSize = hasSizeOption ? this.getSelectedSize() : null;

  if (this.stickySelection) {
    this.stickySelection.textContent = hasSizeOption
      ? (selectedSize ? `Size: ${selectedSize}` : 'Size: Select')
      : '';
  }

  const available = !!this.currentVariant.available;

  if (this.stickyAddBtn) {
    this.stickyAddBtn.disabled = !available;
    this.stickyAddBtn.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
  }

  if (available && hasSizeOption && !selectedSize) {
    if (this.stickyAddBtn) this.stickyAddBtn.textContent = 'CONFIRM SIZE';
  }
}    syncOptionUI() {
      this.optionGroups.forEach((group, groupIndex) => {
        const optionName = group.dataset.optionName;
        const selectedValue = this.selectedOptions[groupIndex];
        const selectedTarget = group.querySelector(
          `[data-selected-option="${CSS.escape(optionName)}"]`
        );

        if (selectedTarget && selectedValue) {
          selectedTarget.textContent = selectedValue;
        }

        const buttons = group.querySelectorAll('[data-option-value]');
        buttons.forEach((button) => {
          const value = button.dataset.optionValueLabel;
          button.classList.toggle('is-active', value === selectedValue);
        });

        this.syncOptionAvailabilityForColor(group);
      });
    }

    // Colour-grouped products: a size is only "available" if it is in stock in the selected colour.
    syncOptionAvailabilityForColor(group) {
      if (this.colorOptionIndex < 0) return;

      const position = parseInt(group.dataset.optionPosition || '0', 10) - 1;
      if (position < 0 || position === this.colorOptionIndex) return;

      const color = this.selectedOptions[this.colorOptionIndex];
      const optionName = group.dataset.optionName;
      const colorKey = `option${this.colorOptionIndex + 1}`;
      const valueKey = `option${position + 1}`;

      const isAvailable = (value) =>
        this.product.variants.some(
          (variant) => variant.available && variant[valueKey] === value && (!color || variant[colorKey] === color)
        );

      const buttons = [
        ...group.querySelectorAll('[data-option-value]'),
        ...(this.sizeSheetOptions
          ? Array.from(this.sizeSheetOptions.querySelectorAll('[data-size-sheet-option]')).filter(
              (button) => button.dataset.optionName === optionName
            )
          : [])
      ];

      buttons.forEach((button) => {
        const soldOut = !isAvailable(button.dataset.optionValueLabel);
        button.classList.toggle('is-soldout', soldOut);
        if (soldOut) {
          button.dataset.optionSoldout = 'true';
        } else {
          delete button.dataset.optionSoldout;
        }
      });
    }

    syncVariantInput() {
      if (!this.variantIdInput || !this.currentVariant) return;

      this.variantIdInput.value = this.currentVariant.id;
      this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncPriceUI() {
      if (!this.currentVariant) return;

      const price = this.formatMoney(this.currentVariant.price);
      const comparePrice =
        this.currentVariant.compare_at_price &&
        this.currentVariant.compare_at_price > this.currentVariant.price
          ? this.formatMoney(this.currentVariant.compare_at_price)
          : '';

      if (this.priceCurrent) {
        this.priceCurrent.textContent = price;
      }

      if (this.priceCompare) {
        if (comparePrice) {
          this.priceCompare.textContent = comparePrice;
          this.priceCompare.hidden = false;
        } else {
          this.priceCompare.textContent = '';
          this.priceCompare.hidden = true;
        }
      }

      this.syncDiscountUI();
      this.syncPrepaidOffer();
    }

    // Price after the prepaid discount (percent comes from the section setting).
    syncPrepaidOffer() {
      if (!this.prepaidOffer || !this.prepaidPrice || !this.currentVariant) return;

      const percent = Number(this.prepaidOffer.dataset.prepaidPercent || 0);
      const price = Number(this.currentVariant.price || 0);
      if (!percent || !price) return;

      this.prepaidPrice.textContent = this.formatMoney(Math.floor((price * (100 - percent)) / 100));
    }
    syncDiscountUI() {
      if (!this.currentVariant) return;

      const compareAtPrice = Number(this.currentVariant.compare_at_price || 0);
      const price = Number(this.currentVariant.price || 0);
      const hasDiscount = compareAtPrice > price;
      const discountText = hasDiscount
        ? `${Math.round(((compareAtPrice - price) * 100) / compareAtPrice)}% OFF`
        : '';

      if (this.priceBadge) {
        this.priceBadge.textContent = discountText;
        this.priceBadge.hidden = !hasDiscount;
      }

      if (this.mediaSaleBadges.length) {
        this.mediaSaleBadges.forEach((badge) => {
          badge.textContent = discountText;
          badge.hidden = !hasDiscount;
        });
      }
    }

    syncAvailabilityUI() {
      if (!this.currentVariant) return;

      const available = !!this.currentVariant.available;

      if (this.stockText) {
        this.stockText.textContent = available ? 'In stock' : 'Out of stock';
        this.stockText.classList.toggle('in-stock', available);
        this.stockText.classList.toggle('out-of-stock', !available);
      }

      if (this.addToCartBtn) this.addToCartBtn.disabled = !available;
      if (this.stickyAddBtn) this.stickyAddBtn.disabled = !available;
    }

    syncMediaForVariant() {
      if (!this.currentVariant) return;

      const groupedByColor = this.colorOptionIndex >= 0;
      const colorChanged = this.applyMediaColor(this.getVariantColor(this.currentVariant));
      const activeSlide = this.slides[this.getActiveSlideIndex()];
      const activeExcluded = !!activeSlide && activeSlide.hasAttribute('data-media-excluded');

      // Colour-grouped products only jump when the colour changes (not on a size change).
      if (groupedByColor && !colorChanged && !activeExcluded) return;

      const featured = this.currentVariant.featured_media;
      const targetIndex = featured
        ? this.slides.findIndex((slide) => slide.dataset.mediaId === String(featured.id))
        : -1;

      if (targetIndex >= 0) {
        this.showSlideByIndex(targetIndex);
        return;
      }

      if (groupedByColor) {
        this.showSlideByIndex(this.getNavigableSlideIndexes()[0] || 0);
      }
    }

    syncSizeSheetState() {
      if (!this.sizeSheetOptions || !this.sizeSheetProceed) return;

      const selectedSize = this.getSelectedSize();
      const buttons = this.sizeSheetOptions.querySelectorAll('[data-size-sheet-option]');

      buttons.forEach((button) => {
        const value = button.dataset.optionValueLabel;
        button.classList.toggle('is-active', value === selectedSize);
      });

      this.sizeSheetProceed.disabled =
        !selectedSize || !this.currentVariant || !this.currentVariant.available;
    }

    updateUrlWithVariant(variantId) {
      if (!variantId) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

async addCurrentVariantToBagAndGoToBag() {
  if (this.isProcessingAction) return;
  if (!this.currentVariant || !this.currentVariant.available) return;

  this.setProcessingState(true, 'Adding to bag...');

  let response;
  let payload = null;

  try {
    response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: this.currentVariant.id,
        quantity: 1
      })
    });

    payload = await response.json().catch(() => null);
  } catch (error) {
    console.error('[Megaska PDP] Add to bag failed', error);
    this.setProcessingState(false);
    this.flashStatusMessage('Could not add to bag. Please check your connection and try again.');
    return;
  }

  if (!response.ok) {
    console.error('[Megaska PDP] Add to bag rejected', response.status, payload);
    this.setProcessingState(false);
    this.flashStatusMessage(
      (payload && (payload.description || payload.message)) ||
        'Could not add to bag. Please try again.'
    );
    return;
  }

  this.setProcessingState(false);

  // Same events as before: header bag count + loopd2c cart drawer (OTP / checkout prefill live there).
  document.dispatchEvent(new CustomEvent('megaska:cart-updated'));
  document.dispatchEvent(new CustomEvent('loopdesk:cart-drawer:open'));
}

flashStatusMessage(message, duration = 3200) {
  this.showStatusMessage(message);
  window.clearTimeout(this.statusMessageTimer);
  this.statusMessageTimer = window.setTimeout(() => this.hideStatusMessage(), duration);
}

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }

      return (Number(cents || 0) / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      });
    }
hasSizeOption() {
  return !!this.root.querySelector('[data-option="size"]');
}
    getSelectedSize() {
      const sizeGroup = this.root.querySelector('[data-option="size"]');
      if (!sizeGroup) return null;

      const selected = sizeGroup.querySelector('[data-option-value].is-active');
      return selected ? selected.dataset.optionValueLabel : null;
    }

    getAvailableSizes() {
      const sizeGroup = this.root.querySelector('[data-option="size"]');
      if (!sizeGroup) return [];

      return Array.from(sizeGroup.querySelectorAll('[data-option-value]')).map(
        (item) => item.dataset.optionValueLabel
      );
    }

    isMobile() {
      return window.innerWidth < 769;
    }

    openSizeSheet(actionType) {
  if (!this.sizeSheet || !this.isMobile()) {
    this.addCurrentVariantToBagAndGoToBag();
    return;
  }

  this.pendingAction = actionType;
  this.syncSizeSheetState();

  this.sizeSheet.hidden = false;
  this.sizeSheet.setAttribute('aria-hidden', 'false');
  this.sizeSheet.classList.add('is-open');
  document.documentElement.classList.add('mk-size-sheet-open');
  document.body.classList.add('mk-size-sheet-open');
}

closeSizeSheet() {
  if (!this.sizeSheet) return;

  this.sizeSheet.classList.remove('is-open');
  this.sizeSheet.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('mk-size-sheet-open');
  document.body.classList.remove('mk-size-sheet-open');

  setTimeout(() => {
    this.sizeSheet.hidden = true;
  }, 220);
}

    setupSizeGuideBridge() {
      const api = {
        open: () => {
          document.dispatchEvent(new CustomEvent('megaska:open-sizeguide'));
        },
        close: () => {},
        apply: (sizeLabel) => this.applySize(sizeLabel),
        getSelectedSize: () => this.getSelectedSize(),
        getAvailableSizes: () => this.getAvailableSizes()
      };

      window.megaskaSizeGuide = Object.assign({}, window.megaskaSizeGuide || {}, api);
    }

    applySize(sizeLabel) {
  if (!sizeLabel) return false;

  const sizeGroup = this.root.querySelector('[data-option="size"]');
  if (!sizeGroup) return false;

  const target = String(sizeLabel).trim().toLowerCase();

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/-/g, '');

  const wanted = normalize(target);

  const button = Array.from(sizeGroup.querySelectorAll('[data-option-value]')).find((item) => {
    const label = normalize(item.dataset.optionValueLabel || '');
    return label === wanted;
  });

  if (!button || button.dataset.optionSoldout === 'true') return false;

  button.click();
  return true;
}

    setupIntersectionObserver() {
      if (!this.stickyRoot || !this.isMobile()) return;

      const buybox = this.root.querySelector('.mk-product-buybox');
      if (!buybox || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.stickyRoot.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(buybox);
    }
    copyStickyCoupon() {
      const couponCode = this.stickyOfferBtn ? (this.stickyOfferBtn.dataset.couponCode || '').trim() : '';
      if (!couponCode) return;
      const showCopiedState = () => {
        if (!this.stickyOfferBtn) return;
        this.stickyOfferBtn.classList.add('is-copied');
        window.setTimeout(() => {
          this.stickyOfferBtn.classList.remove('is-copied');
        }, 1400);
      };

      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard
          .writeText(couponCode)
          .then(showCopiedState)
          .catch(() => showCopiedState());
        return;
      }

      showCopiedState();
    }
  }

  function initMegaskaProducts() {
    const roots = document.querySelectorAll('[data-product-root]');

    roots.forEach((root) => {
      if (root.dataset.megaskaReady === 'true') return;
      root.dataset.megaskaReady = 'true';
      new MegaskaProduct(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaskaProducts);
  } else {
    initMegaskaProducts();
  }
})();
